import { useHistory } from "react-router-dom";
import ToggleSwitch from "./ToggleSwitch";

interface Props {
  startingOption:
    | "Software Support"
    | "Software Versions"
    | "Hardware"
    | "Firmware"
    | "Utility Software";
}

const LinksToggleSwitch = ({ startingOption }: Props) => {
  const { push } = useHistory();
  return (
    <ToggleSwitch
      options={[
        "Software Support",
        "Software Versions",
        "Hardware",
        "Firmware",
        "Utility Software",
      ]}
      onClicks={[
        () => {
          push("/software-links");
        },
        () => {
          push("/links");
        },
        () => {
          push("/analyzer-type-links");
        },
        () => {
          push("/firmware");
        },
        () => {
          push("/utilities");
        },
      ]}
      startingOption={startingOption}
    />
  );
};

export default LinksToggleSwitch;
